<script>
  import { link } from 'svelte-spa-router';
</script>

<nav class="navbar navbar-expand-lg navbar-primary bg-primary">
  <a class="navbar-brand text-white " href="/" use:link>API Películas</a>
</nav>
